import { useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, P } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../NavBar/NavBar.js';
import CommandBar from '../CommandBar/CommandBar.js';
import '../CommandBar/CommandButton.js';
import './DashboardContext.js';
import useDashboard from './use-dashboard.js';
import Tile from '../Tile/Tile.js';
import { H6 } from '../H6/H6.js';

const _excluded = ["children", "icon", "title", "subTitle", "height", "farItems", "removable", "iconTooltipExpand", "iconTooltipCollapse", "iconTooltipLock", "iconTooltipUnlock", "id", "expandable", "lockable", "isMaximized", "isLocked", "tileStyles"];
function WidgetComponentBase(_ref) {
  let {
      children,
      icon,
      title,
      subTitle,
      height,
      farItems,
      removable,
      iconTooltipExpand,
      iconTooltipCollapse,
      iconTooltipLock,
      iconTooltipUnlock,
      id,
      expandable,
      lockable,
      isMaximized,
      isLocked,
      tileStyles
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const [, dispatch] = useDashboard();
  const headerHeight = (farItems === null || farItems === void 0 ? void 0 : farItems.length) > 0 || title || subTitle || icon || removable || expandable || lockable ? 50 : 0;
  const removableItem = removable ? {
    key: 'maximize',
    iconProps: {
      glyph: icons.TRASH
    },
    onClick: () => dispatch({
      type: 'REMOVE_LAYOUT',
      id
    }),
    iconOnly: true,
    styles: {
      root: {
        width: 50
      }
    }
  } : null;
  const expandableItem = expandable ? {
    key: 'maximize',
    iconProps: {
      glyph: isMaximized ? icons.COLLAPSE : icons.EXPAND
    },
    text: isMaximized ? iconTooltipCollapse : iconTooltipExpand,
    tooltipProps: {
      message: isMaximized ? iconTooltipCollapse : iconTooltipExpand,
      placement: 'left'
    },
    onClick: () => isMaximized ? dispatch({
      type: 'REMOVE_FULLSCREEN'
    }) : dispatch({
      type: 'SET_FULLSCREEN',
      id
    }),
    iconOnly: true,
    styles: {
      root: {
        width: 50
      }
    }
  } : null;
  const lockItem = lockable ? {
    key: 'lock',
    iconProps: {
      glyph: isLocked ? icons.LINK : icons.NO_LINK
    },
    text: isLocked ? iconTooltipUnlock : iconTooltipLock,
    tooltipProps: {
      message: isLocked ? iconTooltipUnlock : iconTooltipLock,
      placement: 'left'
    },
    onClick: () => dispatch({
      type: isLocked ? 'UNLOCK_LAYOUT' : 'LOCK_LAYOUT',
      id
    }),
    iconOnly: true,
    styles: {
      root: {
        width: 50
      }
    }
  } : null;
  return /*#__PURE__*/createElement(Tile, _extends({
    styles: _objectSpread2(_objectSpread2({}, tileStyles), {}, {
      header: _objectSpread2({
        p: 0,
        height: headerHeight,
        width: '100%'
      }, tileStyles === null || tileStyles === void 0 ? void 0 : tileStyles.header),
      content: _objectSpread2({
        p: 0,
        height: height - headerHeight,
        overflowY: 'auto',
        overflowX: 'auto'
      }, tileStyles === null || tileStyles === void 0 ? void 0 : tileStyles.content),
      root: _objectSpread2({
        height: '100%'
      }, tileStyles === null || tileStyles === void 0 ? void 0 : tileStyles.root)
    }),
    header: headerHeight > 0 ? /*#__PURE__*/createElement(CommandBar, {
      styles: {
        root: {
          width: '100%',
          boxShadow: 'none',
          zIndex: 'unset'
        }
      },
      items: [{
        key: 'title',
        onRender: () => /*#__PURE__*/createElement(Div, {
          display: "flex",
          alignItems: "center",
          pl: theme.spacing.sm
        }, /*#__PURE__*/createElement(Icon, {
          size: 32,
          glyph: icon,
          styles: {
            root: {
              color: theme.palette.secondary.main,
              ml: `-${theme.spacing.xxs}px`,
              mr: `${theme.spacing.xxs}px`
            }
          }
        }), /*#__PURE__*/createElement(Div, null, /*#__PURE__*/createElement(H6, {
          lineHeight: 1.25
        }, title), /*#__PURE__*/createElement(P, {
          fontSize: theme.typography.pxToRem(10),
          color: theme.palette.text.secondary,
          lineHeight: 1.25
        }, subTitle)))
      }],
      farItems: [...(farItems || []), ...(expandableItem ? [expandableItem] : []), ...(lockItem ? [lockItem] : []), ...(removableItem ? [removableItem] : [])]
    }) : null
  }, rest), children);
}

export default WidgetComponentBase;
